import './SelectionPageStyle.scss';
import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';

export function SelectionPage() {
    const [tapCount, setTapCount] = useState(0);

    var urlInmaculada = "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-inmaculada.jpg?alt=media&token=bc6af098-70fb-4480-b88f-42f791a3a079&_gl=1*gzs9vm*_ga*MTAwODI3MDM3My4xNjkzNDkxNzE0*_ga_CW55HF8NVT*MTY5NzcxNDQ2My4xOC4xLjE2OTc3MTQ1OTcuNDcuMC4w"
    const navigate = useNavigate();

    function goTo(equipo) {
        return ()=> navigate("/"+equipo);
    }

    const handleSecretTap = () => {
        setTapCount(prev => {
            const nextCount = prev + 1;

            if (nextCount >= 10) {
                navigate('/fantasy/home');
                return 0;
            }

            return nextCount;
        });
    };

    return (
        <main className="main">
            <div className="blue-line-top">
                <div className="page-title-text">
                    Nuestros equipos
                </div>
            </div>

            <div className="container-all-images">
                <div className="team-container" onClick={goTo("InmaculadaA")}>
                    <img src={urlInmaculada} className="team-image" alt="escudo" />
                    <div className='team-name'>
                        A.A. INMACULADA 'A' - RV MEDICINA ESTETICA
                    </div>
                    <div className='team-category'>
                        1º FBPA Masculina
                    </div>
                </div>

                <div className="team-container" onClick={goTo("InmaculadaB")}>
                    <img src={urlInmaculada} className="team-image" alt="escudo" />
                    <div className='team-name'>
                        A.A. INMACULADA 'B'
                    </div>
                    <div className='team-category'>
                        3º FBPA Masculina
                    </div>
                </div>

                {/*<div className="team-container"onClick={goTo("InmaculadaFem")}>
                    <img src={urlInmaculada} className="team-image" alt="escudo" />
                    <div className='team-name'>
                        A.A. INMACULADA - APV
                    </div>
                    <div className='team-category'>
                        2º FBPA Femenina
                    </div>
                </div>*/}
            </div>

            <div
                className="secret-fantasy-button"
                role="button"
                tabIndex={0}
                aria-label="Acceso secreto a fantasy"
                onClick={handleSecretTap}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleSecretTap();
                    }
                }}
            />
        </main>
    );
}
